import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { SESSION_STORE_KEY } from '@connect-services/client/resolvers/session.resolver';
import { FeatureSession, FeatureSessionService as FeatureSessionServiceSdk } from '@connect-services/src/sdk/api';

export const FEATURE_SESSION_STORE_KEY = 'featureSession';
export const FEATURE_TRACKED_STORE_KEY = 'featureTracked';

@Injectable({
    providedIn: 'root',
})
export class FeatureSessionService {
    private featureSessionService = inject(FeatureSessionServiceSdk);

    public async endSession(featureSession: string, removeItem: boolean = true): Promise<void> {
        try {
            await firstValueFrom(this.featureSessionService.featureSessionControllerPatch({ id: featureSession }));

            if (!removeItem) {
                return;
            }

            sessionStorage.removeItem(FEATURE_SESSION_STORE_KEY);
            sessionStorage.removeItem(FEATURE_TRACKED_STORE_KEY);
        } catch {
            /* empty */
        }
    }

    public async startFeatureSession(
        featureTracked: FeatureSession.FeatureTrackedEnum,
        setItem: boolean = true,
    ): Promise<string | undefined> {
        const sessionId = sessionStorage.getItem(SESSION_STORE_KEY);

        if (!sessionId) {
            return undefined;
        }

        const featureSession = await firstValueFrom(
            this.featureSessionService.featureSessionControllerPost({
                createFeatureSessionDto: {
                    featureTracked,
                    session: sessionId,
                },
            }),
        );

        if (setItem) {
            sessionStorage.setItem(FEATURE_SESSION_STORE_KEY, featureSession.id);
            sessionStorage.setItem(FEATURE_TRACKED_STORE_KEY, featureTracked);
        }

        return featureSession.id;
    }
}
